import { render, staticRenderFns } from "./ShopifyPackages.vue?vue&type=template&id=e0d32914&"
import script from "./ShopifyPackages.vue?vue&type=script&lang=js&"
export * from "./ShopifyPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShopifyPackages.vue"
export default component.exports